import { SvelteComponent, init, safe_not_equal, create_component, mount_component, transition_in, transition_out, destroy_component, create_slot, text, insert, noop, detach, element, space, attr, append, listen, check_outros, update_slot_base, get_all_dirty_from_scope, get_slot_changes, group_outros } from '../../../../external_node_modules/svelte/internal/index.mjs.js';
import { t } from '../../../../i18n.js';
import EscButton from '../EscButton/EscButton.svelte.js';
import './assets/styles/purchaseRestriction.scss.js';
import './PurchaseRestrictionPopup.css.js';

/* src/ui/shared/components/PurchaseRestrictionPopup/PurchaseRestrictionPopup.svelte generated by Svelte v3.44.2 */
const get_purchase_restriction_content_slot_changes = dirty => ({});
const get_purchase_restriction_content_slot_context = ctx => ({});
const get_purchase_restriction_title_slot_changes = dirty => ({});
const get_purchase_restriction_title_slot_context = ctx => ({});

// (17:2) {#if isClosable}
function create_if_block(ctx) {
	let escbutton;
	let current;

	escbutton = new EscButton({
			props: { handleClick: /*closeApplication*/ ctx[2] }
		});

	return {
		c() {
			create_component(escbutton.$$.fragment);
		},
		m(target, anchor) {
			mount_component(escbutton, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const escbutton_changes = {};
			if (dirty & /*closeApplication*/ 4) escbutton_changes.handleClick = /*closeApplication*/ ctx[2];
			escbutton.$set(escbutton_changes);
		},
		i(local) {
			if (current) return;
			transition_in(escbutton.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(escbutton.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(escbutton, detaching);
		}
	};
}

// (23:46)          
function fallback_block(ctx) {
	let t_1_value = t('Внимание!') + "";
	let t_1;

	return {
		c() {
			t_1 = text(t_1_value);
		},
		m(target, anchor) {
			insert(target, t_1, anchor);
		},
		p: noop,
		d(detaching) {
			if (detaching) detach(t_1);
		}
	};
}

function create_fragment(ctx) {
	let div1;
	let t0;
	let div0;
	let h1;
	let t1;
	let current;
	let mounted;
	let dispose;
	let if_block = /*isClosable*/ ctx[1] && create_if_block(ctx);
	const purchase_restriction_title_slot_template = /*#slots*/ ctx[5]["purchase-restriction-title"];
	const purchase_restriction_title_slot = create_slot(purchase_restriction_title_slot_template, ctx, /*$$scope*/ ctx[4], get_purchase_restriction_title_slot_context);
	const purchase_restriction_title_slot_or_fallback = purchase_restriction_title_slot || fallback_block();
	const purchase_restriction_content_slot_template = /*#slots*/ ctx[5]["purchase-restriction-content"];
	const purchase_restriction_content_slot = create_slot(purchase_restriction_content_slot_template, ctx, /*$$scope*/ ctx[4], get_purchase_restriction_content_slot_context);

	return {
		c() {
			div1 = element("div");
			if (if_block) if_block.c();
			t0 = space();
			div0 = element("div");
			h1 = element("h1");
			if (purchase_restriction_title_slot_or_fallback) purchase_restriction_title_slot_or_fallback.c();
			t1 = space();
			if (purchase_restriction_content_slot) purchase_restriction_content_slot.c();
			attr(h1, "class", "purchase-restriction__title");
			attr(div0, "class", "purchase-restriction");
			attr(div1, "id", /*purchaseRestrictionId*/ ctx[0]);
			attr(div1, "class", "purchase-restriction-overlay");
		},
		m(target, anchor) {
			insert(target, div1, anchor);
			if (if_block) if_block.m(div1, null);
			append(div1, t0);
			append(div1, div0);
			append(div0, h1);

			if (purchase_restriction_title_slot_or_fallback) {
				purchase_restriction_title_slot_or_fallback.m(h1, null);
			}

			append(div0, t1);

			if (purchase_restriction_content_slot) {
				purchase_restriction_content_slot.m(div0, null);
			}

			current = true;

			if (!mounted) {
				dispose = listen(window, "keydown", /*handleKeydown*/ ctx[3]);
				mounted = true;
			}
		},
		p(ctx, [dirty]) {
			if (/*isClosable*/ ctx[1]) {
				if (if_block) {
					if_block.p(ctx, dirty);

					if (dirty & /*isClosable*/ 2) {
						transition_in(if_block, 1);
					}
				} else {
					if_block = create_if_block(ctx);
					if_block.c();
					transition_in(if_block, 1);
					if_block.m(div1, t0);
				}
			} else if (if_block) {
				group_outros();

				transition_out(if_block, 1, 1, () => {
					if_block = null;
				});

				check_outros();
			}

			if (purchase_restriction_title_slot) {
				if (purchase_restriction_title_slot.p && (!current || dirty & /*$$scope*/ 16)) {
					update_slot_base(
						purchase_restriction_title_slot,
						purchase_restriction_title_slot_template,
						ctx,
						/*$$scope*/ ctx[4],
						!current
						? get_all_dirty_from_scope(/*$$scope*/ ctx[4])
						: get_slot_changes(purchase_restriction_title_slot_template, /*$$scope*/ ctx[4], dirty, get_purchase_restriction_title_slot_changes),
						get_purchase_restriction_title_slot_context
					);
				}
			}

			if (purchase_restriction_content_slot) {
				if (purchase_restriction_content_slot.p && (!current || dirty & /*$$scope*/ 16)) {
					update_slot_base(
						purchase_restriction_content_slot,
						purchase_restriction_content_slot_template,
						ctx,
						/*$$scope*/ ctx[4],
						!current
						? get_all_dirty_from_scope(/*$$scope*/ ctx[4])
						: get_slot_changes(purchase_restriction_content_slot_template, /*$$scope*/ ctx[4], dirty, get_purchase_restriction_content_slot_changes),
						get_purchase_restriction_content_slot_context
					);
				}
			}

			if (!current || dirty & /*purchaseRestrictionId*/ 1) {
				attr(div1, "id", /*purchaseRestrictionId*/ ctx[0]);
			}
		},
		i(local) {
			if (current) return;
			transition_in(if_block);
			transition_in(purchase_restriction_title_slot_or_fallback, local);
			transition_in(purchase_restriction_content_slot, local);
			current = true;
		},
		o(local) {
			transition_out(if_block);
			transition_out(purchase_restriction_title_slot_or_fallback, local);
			transition_out(purchase_restriction_content_slot, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div1);
			if (if_block) if_block.d();
			if (purchase_restriction_title_slot_or_fallback) purchase_restriction_title_slot_or_fallback.d(detaching);
			if (purchase_restriction_content_slot) purchase_restriction_content_slot.d(detaching);
			mounted = false;
			dispose();
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let { $$slots: slots = {}, $$scope } = $$props;
	let { purchaseRestrictionId } = $$props;
	let { isClosable } = $$props;
	let { closeApplication } = $$props;

	function handleKeydown(e) {
		if (isClosable && e.key === 'Escape') {
			closeApplication();
		}
	}

	$$self.$$set = $$props => {
		if ('purchaseRestrictionId' in $$props) $$invalidate(0, purchaseRestrictionId = $$props.purchaseRestrictionId);
		if ('isClosable' in $$props) $$invalidate(1, isClosable = $$props.isClosable);
		if ('closeApplication' in $$props) $$invalidate(2, closeApplication = $$props.closeApplication);
		if ('$$scope' in $$props) $$invalidate(4, $$scope = $$props.$$scope);
	};

	return [
		purchaseRestrictionId,
		isClosable,
		closeApplication,
		handleKeydown,
		$$scope,
		slots
	];
}

class PurchaseRestrictionPopup extends SvelteComponent {
	constructor(options) {
		super();

		init(this, options, instance, create_fragment, safe_not_equal, {
			purchaseRestrictionId: 0,
			isClosable: 1,
			closeApplication: 2
		});
	}
}

export { PurchaseRestrictionPopup as default };
//# sourceMappingURL=PurchaseRestrictionPopup.svelte.js.map
